export default {
    list: {
        method: 'POST',
        url: '/admin/approval/list',
        name: '审核管理数据表',
    },
    storeOut:{
        method:'GET',
        url:'/admin/approval/storeOut/{id}',
        name:'出库详情'
    },
    storeTransfer:{
        method:'GET',
        url:'/admin/approval/storeTransfer/{id}',
        name:'调拨详情'
    },
    refund:{
        method:'GET',
        url:'/manage-system/approval/{id}',
        name:'退款详情'
    },
    pass: {
        method: 'PUT',
        url: '/manage-system/approval/pass/{id}',
        name: '审核管理审核通过',
    },
    passp: {
        method: 'POST',
        url: '/manage-system/approval/passp',
        name: '审核管理审核通过',
    },
    cancel: {
        method: "PUT",
        url: "/manage-system/approval/cancel/{id}",
        name: "撤回审批",
    },
    unPass: {
        method: 'PUT',
        url: '/manage-system/approval/unpass/{id}',
        name: '审核管理审核不通过',
    },
    listByConfirm: {
        method: 'POST',
        url: '/manage-system/approval/review/my',
        name: '审批列表(待我确认)',
    },
    listByMe: {
        method: 'POST',
        url: '/manage-system/approval/apply/my',
        name: '审批列表(我发起的)',
    },
    ticketRefund: {
        method: 'GET',
        url: '/admin/approval/ticketRefund/{id}',
        name: '票劵退款详情',
    },
    orderRefund: {
        method: 'GET',
        url: '/manage-system/approval/{refundNo}',
        name: '订单退款详情',
    },
    sysRoleRefund: {
        method: 'GET',
        url: '/manage-system/role/approval',
        name: '退款审核人职位列表(门店id)',
    },
    sysUserRefund: {
        method: 'GET',
        url: '/manage-system/staff/listByRole',
        name: '退款审核人列表(门店id)',
    },
    viewRefundOrder: {
        method: 'GET',
        url: '/admin/approval/viewRefundOrder/{businessId}',
        name: '查看退款订单',
    },
    isNeedAlert: {
        method: 'GET',
        url: '/manage-system/approval/isNeedAlert/{id}',
        name: '判断是否需要弹窗提示',
    }
}